export default "__VITE_ASSET__Cwzn3vbP__"